import { API_CONFIG } from 'shared/constants/constants';
import HttpService from 'shared/services/http.service';
import { AiAskResponse, AiConversation, AiConversationDetail } from '../interface/ai';

export interface ConversationListParams {
	page: number;
	perPage: number;
	orderBy: string;
	sort: 'asc' | 'desc';
	search?: string;
}

export const fetchConversations = (params: ConversationListParams) =>
	HttpService.get(API_CONFIG.path.aiConversations, params) as Promise<{
		items: AiConversation[];
		pagination: { total: number; currentPageItems: number };
	}>;

export const fetchConversation = (conversationId: string) =>
	HttpService.get(`${API_CONFIG.path.aiConversations}/${conversationId}`, {}) as Promise<AiConversationDetail>;

export const askAi = (payload: { prompt: string; conversationId?: string }) =>
	HttpService.post(API_CONFIG.path.aiAsk, payload) as Promise<AiAskResponse>;

export const updateConversationTitle = (conversationId: string, title: string) =>
	HttpService.patch(`${API_CONFIG.path.aiConversations}/${conversationId}/title`, {
		title
	}) as Promise<AiConversation>;

export const deleteConversation = (conversationId: string) =>
	HttpService.deleteRequest(`${API_CONFIG.path.aiConversations}/${conversationId}`, {}) as Promise<{
		conversationId: string;
	}>;
